import { useEffect } from 'react';
import PropTypes from 'prop-types';
import TagManager from 'react-gtm-module';
import { isGoogleTagManagerEnabled } from '../helpers/tag-manager';

const GoogleTagManagerProvider = ({ children }) => {
  useEffect(() => {
    if (isGoogleTagManagerEnabled()) {
      TagManager.initialize({ gtmId: process.env.REACT_APP_GTM_ID });
    }
  }, []);

  return children;
};

GoogleTagManagerProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GoogleTagManagerProvider;
